import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CustomNextArrow, CustomPrevArrow } from "../../utility/CustomArrow";

const OurTeamHome = ({ data }) => {
  const teamMembers = data?.data_values || [];

  const settings = {
    dots: teamMembers.length > 1,
    infinite: teamMembers.length > 1,
    speed: 600,
    autoplay: teamMembers.length > 1,
    pauseOnHover: false,
    arrows: teamMembers.length > 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    autoplaySpeed: 4000,
    slidesToShow: Math.min(4, teamMembers.length),
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: Math.min(2, teamMembers.length) },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: Math.min(2, teamMembers.length) },
      },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <div className="row justify-content-center">
          {/* <div className="col-md-10"> */}
            {" "}
            {/* You can adjust col-md-4, col-md-5 etc. */}
            {teamMembers.length > 0 ? (
              <Slider {...settings} className="slick-slider">
                {teamMembers.map((member, index) => (
                  <div key={index} className="px-3">
                    <div className="rounded">
                      <img
                        src={member.Image}
                        alt="Team Member"
                        className="team-image img-fluid rounded"
                        style={{
                          width: "100%",
                          height: "350px",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <p className="text-center text-muted">
                No team members available.
              </p>
            )}
          </div>
        </div>
      {/* </div> */}
    </section>
  );
};

export default OurTeamHome;
